import { useState } from "react";
import { FiPhone } from "react-icons/fi";
import InputElement from "../../../Common/InputElement";
import ModalElement from "../../../Common/ModalElement";
import { MdOutlineAlternateEmail } from "react-icons/md";
import ButtonElement from "../../../Common/ButtonElement";
import { useApiRequest } from "../../../hooks/useApiRequest";
import { commonOnChange, validateFields } from "../../../utils";
import { appApis } from "../../../constants";
import { TfiReceipt } from "react-icons/tfi";

const AddSuppliers = ({ showLog, hideModal, getSuppliers }) => {
    const [state, setState] = useState({
        suppliers: "",
        phoneNo: "",
        email: "",
        gstNo: "",
        address: "",
    })
    const { suppliers, email, phoneNo, gstNo, address, suppliersErr, emailErr, phoneNoErr } = state;
    const { request, loading } = useApiRequest();
    const onChangeHandler = (event) => commonOnChange(event, setState);

    const submit = () => {
        validateFields(
            {
                suppliersErr: [suppliers, "text"],
                phoneNoErr: [phoneNo, "phone"],
                emailErr: [email, "email"]
            },
            setState,
            () => {
                request({
                    url: appApis.createSupplier,
                    method: "POST",
                    body: {
                        "supplierName": suppliers,
                        "email": email,
                        "gstNumber": gstNo || null,
                        "mobileNo": phoneNo,
                        "address": address
                    },
                    onSuccess: () => {
                        hideModal();
                        getSuppliers();
                    }
                })
            })
    }

    return <ModalElement FooterComponent={<div className="submit-btn text-center my-2">
        <ButtonElement loading={loading} text={"Submit"} cssClass="small-radius" onClick={submit} variant="btn-outline-primary" />
    </div>} size="lg" show={showLog} title={"Add Supplier"} onHide={hideModal}>
        <div className="add-inventory">
            <div className="row w-100">
                <div className=" mb-2 col-md-6">
                    <InputElement
                        label={"Supplier Name"}
                        placeholder={"Enter Supplier Name"}
                        name={"suppliers"}
                        value={suppliers}
                        error={suppliersErr}
                        onChange={onChangeHandler}
                    />
                </div>
                <div className="col-md-6 mb-2">
                    <InputElement
                        label={"Email Id"}
                        placeholder={"Enter Email Id"}
                        name={"email"}
                        value={email}
                        error={emailErr}
                        icon={<MdOutlineAlternateEmail size={20} />}
                        onChange={onChangeHandler}
                    />
                </div>
                <div className="col-md-6 mb-2">
                    <InputElement
                        isRequired={false}
                        label={"GST Number"}
                        placeholder={"Enter GST Number"}
                        name={"gstNo"}
                        value={gstNo}
                        error={false}
                        icon={<TfiReceipt size={20} />}
                        onChange={onChangeHandler}
                    />
                </div>
                <div className="col-md-6 mb-2">
                    <InputElement
                        label={"Mobile Number"}
                        placeholder={"Enter Mobile Number"}
                        name={"phoneNo"}
                        value={phoneNo}
                        error={phoneNoErr}
                        icon={<FiPhone size={20} />}
                        onChange={onChangeHandler}
                    />
                </div>
                <div className="col-12 mb-2">
                    <InputElement
                        isTextArea={true}
                        isRequired={false}
                        label={"Address"}
                        placeholder={"Enter Address"}
                        name={"address"}
                        value={address}
                        error={false}
                        onChange={onChangeHandler}
                    />
                </div>
            </div>
        </div>
    </ModalElement >
}

export default AddSuppliers;